<template>
  <div>
    <div class="nav-bar">
      <!-- 官网导航 -->
      <div class="menu-row" v-if="!isMobile">
        <div class="menu-left">
          <router-link to="/" class="logo">
            <img src="../../assets/images/logo.png" alt="" />
          </router-link>
          <router-link to="/" exact>首页</router-link>
          <router-link
            to="/learning-center"
            :class="{
              'is-active': [
                'myCourse',
                'liveCalendar',
                'myCourseDetail',
              ].includes($route.name),
              'today-have-live': todayHaveLive && isAuthenticated,
            }"
            class="learning-center"
            >学习中心</router-link
          >
          <router-link
            class="settle-in"
            v-if="!(user && user.org_id)"
            to="/org-settled"
            exact
          ></router-link>
          <a v-else :href="adminUrl" target="_blank">管理后台</a>
          <a
            href="/download"
            target="_blank"
            :class="{
              'router-link-active': $route.name === 'Download',
            }"
            >下载</a
          >
          <!-- <router-link to="/about" exact>关于我们</router-link> -->
          <!-- <router-link to="/contact">联系我们</router-link> -->
          <a href="https://help.moguoyunke.com/guide/" target="_blank"
            >帮助中心</a
          >
        </div>
        <div class="menu-right">
          <!-- 搜索 -->
          <SearchInput />
          <el-dropdown
            v-if="isAuthenticated"
            trigger="hover"
            @command="handleMenuBehavior"
            class="user-content"
          >
            <span class="el-dropdown-link">
              <img class="avatar" :src="user.avatar" alt="头像" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="!(user && user.org_id)" command="SettleIn"
                >机构入驻</el-dropdown-item
              >
              <el-dropdown-item v-else command="admin"
                >管理后台</el-dropdown-item
              >
              <el-dropdown-item command="LearningCenter"
                >学习中心</el-dropdown-item
              >
              <el-dropdown-item command="CommentList"
                >课程评价</el-dropdown-item
              >
              <el-dropdown-item command="MyNote">我的笔记</el-dropdown-item>
              <el-dropdown-item command="UserInfo">个人信息</el-dropdown-item>
              <el-dropdown-item command="Exchange">课程兑换</el-dropdown-item>
              <el-dropdown-item command="Trade">我的订单</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="not-login" v-else>
            <button @click="login" class="login">登录</button>
            <span class="divider"></span>
            <button @click="login" class="login">注册</button>
          </div>
        </div>
      </div>
      <!-- h5导航 -->
      <div v-else>
        <el-row class="h5-nav">
          <el-col :span="8">
            <div class="logo-name">
              <i class="el-icon-s-fold" @click="drawer = true"></i>
              <img src="../../assets/images/logo.png" alt="" />
            </div>
          </el-col>
          <el-col :span="16" class="menu-right">
            <router-link to="/learning-center">学习中心</router-link>
            <router-link v-if="!(user && user.org_id)" to="/settle-in"
              >机构入驻</router-link
            >
            <a v-else :href="adminUrl" target="_blank">管理后台</a>
            <el-dropdown
              v-if="isAuthenticated"
              trigger="hover"
              @command="handleMenuBehavior"
              class="user-content"
            >
              <span class="el-dropdown-link">
                <img class="avatar" :src="user.avatar" alt="头像" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="!(user && user.org_id)"
                  command="SettleIn"
                  >机构入驻</el-dropdown-item
                >
                <el-dropdown-item v-else command="admin"
                  >管理后台</el-dropdown-item
                >
                <el-dropdown-item command="LearningCenter"
                  >学习中心</el-dropdown-item
                >
                <el-dropdown-item command="CommentList"
                  >课程评价</el-dropdown-item
                >
                <el-dropdown-item command="UserInfo">个人信息</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div v-else class="not-login">
              <button @click="login" class="login">登录</button>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 抽屉 -->
      <el-drawer
        :with-header="false"
        :visible.sync="drawer"
        direction="ltr"
        append-to-body
        custom-class="navbar-drawer"
      >
        <div class="drawer-top">
          <img class="logo" src="../../assets/images/logo.png" alt="logo" />
          <img
            class="close"
            src="@/assets/img/close@2x.png"
            alt="关闭"
            @click="drawer = false"
          />
        </div>
        <ul class="drawer-nav">
          <router-link
            exact
            tag="li"
            :to="item.path"
            :class="$route.name === item.name ? 'activity' : ''"
            v-for="item in navList"
            :key="item.name"
            @click.native="drawer = false"
          >
            {{ item.title }}
          </router-link>
        </ul>
      </el-drawer>
    </div>
    <!-- 占位元素 -->
    <div class="seize-seat-ele"></div>
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { isH5, isMobile } from "@saas/components/src";
import SearchInput from "./search-input/Index.vue";
import { getCalendarCourseList } from "@saas/server-api/src/learning-center";

export default {
  name: "NavBar",
  data() {
    return {
      keyword: "",
      adminUrl: process.env.VUE_APP_ADMIN_URL,
      isH5: isH5(),
      isMobile: isMobile(),
      drawer: false,
      navList: [
        { title: "首页", name: "Home", path: "/" },
        { title: "关于我们", name: "About", path: "/about" },
        { title: "联系我们", name: "Contact", path: "/contact" },
        { title: "下载", name: "Download", path: "/download" },
      ],
      todayHaveLive: false,
    };
  },
  components: {
    SearchInput,
  },
  methods: {
    ...mapActions(["getProfile"]),
    handleMenuBehavior(command) {
      switch (command) {
        case "SettleIn":
          this.$router.push({ name: command });
          break;
        case "admin":
          window.open(this.adminUrl);
          break;
        case "LearningCenter":
          this.$router.push({ name: command });
          break;
        case "MyNote":
          this.$router.push({ name: command });
          break;
        case "UserInfo":
          this.$router.push({ name: command });
          break;
        case "CommentList":
          this.$router.push({ name: command });
          break;
        case "Exchange":
          let routeData = this.$router.resolve({ name: command });
          window.open(routeData.href);
          break;
        case "Trade":
          this.$router.push({ name: command });
          break;
        case "logout":
          this.logout();
          break;
      }
    },
    logout() {
      this.$chiralConfirmLoading(`是否确认退出账号`, "确定", (val) => {
        if (val) {
          this.$store.dispatch("clearProfile");
        }
      });
    },
    login() {
      this.$loginDialog();
      // let preRoute = window.location.href;
      // window.location.href = `${process.env.VUE_APP_ADMIN_URL}/login?return_url=${preRoute}`;
    },
    judgeTodayHaveLive() {
      let params = {
        begin_at: Math.floor(new Date().setHours(0, 0, 0) / 1000),
        end_at: Math.floor((new Date().setHours(24, 0, 0, 0) - 1000) / 1000),
        page_no: 1,
        page_size: 1,
        is_calendar: 0,
      };
      getCalendarCourseList(params).then((res) => {
        if (res.code === 1) {
          let data = res.data?.list || [];
          if (data.length > 0) {
            this.todayHaveLive = true;
          }
        }
      });
    },
  },
  mounted() {
    this.getProfile();
  },
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
  },
  watch: {
    isAuthenticated(val) {
      if (val) {
        this.judgeTodayHaveLive();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
//占位元素
.seize-seat-ele {
  height: 70px;
}
@media (max-width: 767px) {
  .seize-seat-ele {
    height: 1.6rem;
  }
}
.nav-bar {
  position: fixed;
  width: 100%;
  top: 0;
  font-size: 16px;
  color: $plain-text-color;
  line-height: 22px;
  background: #ffffff;
  z-index: 1001;
  background: #fff;
  .learning-center.today-have-live {
    position: relative;
    &::after {
      position: absolute;
      width: 54px;
      height: 20px;
      display: block;
      content: "";
      background: url("../../assets/images/navbar/today-have-live.png");
      background-size: 100% 100%;
      left: 50%;
      // top: -15px;
      bottom: -15px;
      transform: translateX(-50%);
    }
  }
  //
  .settle-in {
    position: relative;
    background: url("../../assets/images/navbar/un-active-settle.png");
    background-size: 100% 100%;
    width: 64px;
    height: 18px;
    margin-top: 9px;
    margin-bottom: 5px;
    // padding: 0 !important;
    // line-height: 1 !important;
    color: transparent;
    &:hover {
      background: url("../../assets/images/navbar/active-settle.png");
      background-size: 100% 100%;
      // font-weight: 500;
      // font-size: 16px;
      // color: $saas-text-color;
      // line-height: 22px;
      // background: linear-gradient(
      //   41.94400710581127deg,
      //   $linear-gradient-begin 0%,
      //   $linear-gradient-end 100%
      // );
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }

    &::after {
      position: absolute;
      width: 35px;
      height: 20px;
      display: block;
      content: "";
      background: url("../../assets/images/navbar/free.png");
      background-size: 100% 100%;
      left: 50%;
      top: -22px;
      transform: translateX(-50%);
    }
  }
  .menu-row {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: $nav-bar-height;
    .search-input {
      margin-right: 20px;
      width: 172px;
      .el-icon-search {
        cursor: pointer;
      }
    }
    ::v-deep .search-input input {
      background: linear-gradient(
        135deg,
        #f7fffc 0%,
        #feffff 47%,
        #f9fffa 100%
      );
    }
    ::v-deep .el-input__inner {
      border-radius: 8px;
      border: 1px solid rgba($color: $saas-border-color, $alpha: 0.49);
    }
    ::v-deep .el-input__inner::placeholder {
      font-size: 12px;
      color: #888988;
    }
    .menu-left {
      display: flex;
      align-items: center;
      & > a {
        margin-right: 30px;
        padding: 5px;
        font-size: 16px;
        color: $plain-text-color;
        line-height: 22px;
        &:hover {
          font-weight: 500;
          color: $saas-theme-color;
        }
      }
      .logo {
        display: flex;
        align-items: center;
        padding: 0;
        margin-right: 97px;
        img {
          width: 126px;
        }
      }
    }
    .menu-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      & > a {
        margin-right: 20px;
        padding: 5px;
      }
      .user-content {
        .avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
        }
      }
      .not-login {
        text-align: right;
        .login {
          font-size: 16px;
          color: $plain-text-color;
          line-height: 22px;
          padding: 5px;
        }
        .divider {
          display: inline-block;
          margin: 0 3px;
          width: 1px;
          height: 10px;
          background: #bcbcbd;
        }
      }
      .not-login .login:hover {
        font-weight: 500;
        color: $saas-theme-color;
      }
    }
  }

  // h5
  .h5-nav {
    height: 1.6rem;
    padding: 0 0.27rem 0;
    background: #ffffff;
    box-shadow: inset 0 -1px #ededed;
    display: flex;
    align-items: center;
    .logo-name {
      font-size: 0.43rem;
      display: flex;
      align-items: center;
      img {
        width: 2.4rem;
        margin-left: 0.27rem;
      }
    }
    .menu-right {
      justify-content: flex-end;
      align-items: center;
      display: flex;
      a {
        margin-right: 0.27rem;
      }
      .login {
        padding: 0.16rem 0.48rem;
        border-radius: 0.48rem;
        border: 1px solid $saas-theme-color;
        color: $saas-theme-color;
        background: #fff;
        font-size: 0.37rem;
        font-weight: 400;
      }
      .avatar {
        width: 0.85rem;
        height: 0.85rem;
        border-radius: 50%;
      }
    }
  }
}
// 抽屉
:deep .navbar-drawer.el-drawer {
  width: 6.4rem !important;
}
.navbar-drawer {
  .drawer-top {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.6533rem;
    margin-bottom: 0.6667rem;
    position: relative;
    .logo {
      width: 2.67rem;
    }
    .close {
      width: 0.32rem;
      height: 0.32rem;
      position: absolute;
      right: 0.32rem;
    }
  }
  .drawer-nav {
    // padding-top: 1.2rem;
    font-size: 0.4267rem;
    li {
      padding: 0.4rem 1.0667rem;
      text-align: center;
      font-size: 0.4rem;
      font-weight: 500;
      color: $chiral-color;
      line-height: 0.56rem;
    }
    .activity {
      background: #f9f9fb;
    }
  }
}

// 适配
@media (max-width: 1200px) {
  .nav-bar {
    .menu-row {
      width: 100%;
      padding: 0.2rem;
    }
  }
}
@media (max-width: 992px) {
  .nav-bar {
    .menu-row {
      font-size: 15px;
    }
  }
}
.is-active,
.router-link-active {
  color: $saas-theme-color !important;
  font-weight: 500;
  &.settle-in {
    background: url("../../assets/images/navbar/active-settle.png");
    background-size: 100% 100%;
  }
  &.learning-center.today-have-live::after {
    display: none;
  }
}
</style>
